import {
  Car, Truck, AlertTriangle, Wrench, ShieldCheck, Anchor,
  Caravan, PackageOpen, Forklift, Bus, Container, Siren,
} from "lucide-react";

export const SERVICES = [
  {
    slug: "car-towing",
    title: "Car Towing",
    short: "Safe local & long-distance car towing across Victoria.",
    icon: Car,
    benefits: ["Sedans, SUVs & utes", "Damage-free loading", "Statewide coverage"],
    description:
      "Whether your car has broken down, been in a collision, or simply needs to be moved across town, our team handles every passenger vehicle with care. Friendly drivers, modern equipment and fair, upfront pricing.",
  },
  {
    slug: "emergency-towing",
    title: "Emergency Towing",
    short: "24/7 rapid response when every minute matters.",
    icon: Siren,
    benefits: ["24/7 dispatch", "Fast ETAs", "Priority for accidents"],
    description:
      "Stranded on the highway? Involved in a crash? Call us anytime, day or night. Our trucks are on standby across Victoria so help reaches you as quickly as possible.",
  },
  {
    slug: "roadside-assistance",
    title: "Roadside Assistance",
    short: "Flat tyre, dead battery, lockout — we sort it on the spot.",
    icon: Wrench,
    benefits: ["Battery jump-starts", "Tyre changes", "Fuel delivery & lockouts"],
    description:
      "Most breakdowns don't need a tow. Our roadside team can get you moving again with quick on-site fixes — saving you time and money.",
  },
  {
    slug: "flatbed-towing",
    title: "Flatbed Towing",
    short: "Damage-free flatbed transport for accident & luxury vehicles.",
    icon: Truck,
    benefits: ["Accident recovery", "Low-clearance vehicles", "All four wheels off the ground"],
    description:
      "Our flatbed trucks are the safest way to move accident-damaged, modified or luxury cars without putting any extra strain on the drivetrain.",
  },
  {
    slug: "enclosed-towing",
    title: "Enclosed Towing",
    short: "Premium enclosed transport for high-value vehicles.",
    icon: Container,
    benefits: ["Weather protected", "Discreet transport", "Soft tie-downs"],
    description:
      "Classic, exotic or show cars deserve the best. Our enclosed transport keeps your prized vehicle safe from the elements and prying eyes.",
  },
  {
    slug: "equipment-transport",
    title: "Equipment Transport",
    short: "Move heavy equipment, machinery & forklifts safely.",
    icon: Forklift,
    benefits: ["Skid steers & forklifts", "Job-site delivery", "Secure tie-down"],
    description:
      "From construction sites to warehouses, we transport equipment of all sizes around Victoria with the right truck for the job.",
  },
  {
    slug: "heavy-vehicle-towing",
    title: "Heavy & Medium Vehicle Towing",
    short: "Built for trucks, buses and heavy commercial vehicles.",
    icon: Bus,
    benefits: ["Up to heavy rigid", "Insurance-friendly", "Recovery experts"],
    description:
      "We tow medium and heavy commercial vehicles — including light trucks, buses and box trucks — using the proper equipment and trained operators.",
  },
  {
    slug: "caravan-transport",
    title: "Caravan & RV Transport",
    short: "Caravans, campers & RVs delivered statewide.",
    icon: Caravan,
    benefits: ["Single & dual axle", "RV transport", "Secure & insured"],
    description:
      "Selling, buying or relocating? We transport caravans, motorhomes and RVs across Victoria with great care and at a price you'll love.",
  },
  {
    slug: "boat-transport",
    title: "Boat Transport",
    short: "Trailered boats moved safely to ramps or storage.",
    icon: Anchor,
    benefits: ["Trailered boats", "Ramp pickup", "Safe strapping"],
    description:
      "We move boats on trailers between marinas, homes, storage yards and ramps — perfect for owners who don't want to tow themselves.",
  },
  {
    slug: "box-truck-transport",
    title: "Box Truck Transport",
    short: "Box trucks moved between depots, sales & sites.",
    icon: PackageOpen,
    benefits: ["Inter-depot moves", "Dealer transfers", "Recovery support"],
    description:
      "Reliable, affordable transport for box trucks and small commercial vehicles — ideal for fleets and small businesses across Victoria.",
  },
  {
    slug: "incident-management",
    title: "Incident Management",
    short: "On-scene coordination for accidents & breakdowns.",
    icon: AlertTriangle,
    benefits: ["Scene safety", "Insurance liaison", "Vehicle recovery"],
    description:
      "After a serious incident, we coordinate with police, insurers and panel shops so your vehicle ends up exactly where it needs to be — fast.",
  },
  {
    slug: "passenger-vehicle-towing",
    title: "Passenger Vehicle Towing",
    short: "Family cars, hatchbacks & sedans handled with care.",
    icon: ShieldCheck,
    benefits: ["Damage-free", "Friendly drivers", "Affordable rates"],
    description:
      "Most jobs are passenger cars and we treat every single one like it's our own. Clean trucks, careful loading, fair pricing.",
  },
];
